import { SetFilterValuesFuncParams } from "ag-grid-enterprise";
import moment from "moment";

export const dateComparator = (date1: string, date2: string) => {
    const timeStamp1 = date1
        ? new Date(moment(date1, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")).getTime()
        : 0;
    const timeStamp2 = date2
        ? new Date(moment(date2, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")).getTime()
        : 0;

    return timeStamp1 - timeStamp2;
};

export const infinityDateColDef = (
    headerName: string,
    fieldName: string,
    filterParams?: any,
    dateFormat = "DD/MM/YY"
) => ({
    filter: "agDateColumnFilter",
    headerName,
    comparator: dateComparator,
    filterParams: {
        filterOptions: ["After", "Before", "inRange"],
        ...filterParams,
    },
    valueFormatter: ({ data }: any) => {
        const fieldsNames = fieldName.split(".");
        const dataToUsed =
            fieldsNames.length === 1
                ? data[fieldName]
                : data[fieldsNames[0]]
                ? data[fieldsNames[0]][fieldsNames[1]]
                : null;
        return dataToUsed ? moment(dataToUsed).format(dateFormat) : "N/A";
    },
    valueGetter: ({ data }: any) => {
        const fieldsNames = fieldName.split(".");
        const dataToUsed =
            fieldsNames.length === 1
                ? data[fieldName]
                : data[fieldsNames[0]]
                ? data[fieldsNames[0]][fieldsNames[1]]
                : null;
        return dataToUsed ? `${moment(dataToUsed).format("DD/MM/YYYY HH:mm:ss")}` : "N/A";
    },
});

export const infinitySelectColDef = (
    headerName: string,
    getValuesAsync?: (params: SetFilterValuesFuncParams) => void,
    filterParams?: any
) => {
    let defaultFilterParams = null;

    if (getValuesAsync) {
        defaultFilterParams = {
            filterParams: {
                values: getValuesAsync,
                refreshValuesOnOpen: true,
                filterOptions: ["contains", "notContains"],
                ...filterParams,
            },
        };
    } else {
        defaultFilterParams = {
            filterParams: {
                filterOptions: ["contains", "notContains"],
                ...filterParams,
            },
        };
    }

    return {
        filter: "agSetColumnFilter",
        headerName,
        ...defaultFilterParams,
    };
};

export const infinityNumberColDef = (headerName: string, filterParams?: any) => ({
    filter: "agNumberColumnFilter",
    cellClass: "number-cell",
    headerName,
    filterParams: {
        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
        ...filterParams,
    },
});

export const infinityTextColDef = (headerName: string, filterParams?: any) => ({
    filter: "agTextColumnFilter",
    headerName,
    filterParams: {
        filterOptions: ["contains", "notContains", "blank", "notBlank"],
        ...filterParams,
    },
});
